/**
 * 查看反馈
 */
import React from 'react';
import {Col, Modal, Row, Button, Icon} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import {formatDate} from "../../../utils";
import {Scrollbars} from "react-custom-scrollbars";
import {DetailDialog as Picture} from "../../../view/resource/view/dialog/picture/picture";

export default class OpinionManageView extends BaseComponent {
    static propTypes = {};
    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            title: "",
            currentItem: {}
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    show(record) {
        if (record) {
            this.request({
                url: "/cm-sites-mmp/Feedback/getDetails",
                method: "get",
                body: {id: record.id},
                callBack: (res) => {
                    if (res) {
                        res.photos = res.photos && res.photos.length > 0 && res.photos.map(item => {
                            return {
                                url: item,
                                hover: false
                            }
                        })
                        this.setState({
                            visible: true,
                            title: "查看反馈",
                            currentItem: res
                        })
                    }
                }
            });
        }
    }

    getContent(currentItem) {
        return (
            [
                {
                    title: "问题类型", content: (() => {
                        switch (currentItem.type) {
                            case 1:
                                return "功能bug";
                            case 2:
                                return "内容性建议";
                            case 3:
                                return "其他问题";
                            default:
                                return "";
                        }
                    })()
                },
                {title: "反馈人", content: currentItem.submitUser},
                {title: "手机号码", content: currentItem.submitUserPhone},
                {title: "反馈时间", content: formatDate(currentItem.createTime)},
                {title: "反馈信息", content: currentItem.message},
                {
                    title: "反馈图片", content:
                        currentItem.photos && currentItem.photos.length > 0 && currentItem.photos.map((item, index) => {
                            return (<span style={{
                                display: "inline-block",
                                marginRight: "10px",
                                marginBottom: "10px",
                                position: 'relative'
                            }} key={index}>
                                <img
                                    style={{width: 120, height: 120, objectFit: "cover"}}
                                    alt={"反馈图片"}
                                    src={item.url}
                                    onMouseEnter={() => this.handleEnter(item)}
                                />
                                {/*悬浮按钮*/}
                                {item.hover ? this.renderBtn(item) : null}
                            </span>)
                        })
                },
            ]
        )
    }

    //鼠标悬浮图片按钮
    renderBtn = (item) => {
        return (
            <div style={{
                display: 'block'
            }} onMouseLeave={() => this.handleOut(item)}>
                <div style={{
                    width: 120,
                    height: 120,
                    background: 'rgba(0,0,0,0.4)',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    padding: '0 10px'
                }}>
                    <Icon type={'eye'} style={{width: 20, height: 20, color: "#fff", cursor: 'pointer'}}
                          onClick={() => {
                              this.previewPic = item.url;
                              this.setState({})
                              this.handlePreview();
                          }}
                    />
                </div>
            </div>
        )
    };

    previewPic = "";

    // 预览
    handlePreview = async file => {
        this.detailDialog.show();
    };

    //鼠标移出
    handleOut = (item) => {
        item.hover = false;
        this.setState({})
    };

    //鼠标移入
    handleEnter = (item) => {
        item.hover = true;
        this.setState({})
    };

    render() {
        const {visible, title, currentItem} = this.state;
        const contentArr = this.getContent(currentItem)
        return (
            <Modal
                title={title}
                visible={visible}
                width={600}
                onCancel={() => {
                    this.setState({
                        visible: false
                    })
                }}
                footer={
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><Button
                        onClick={() => {
                            this.setState({
                                visible: false
                            })
                        }}>关闭</Button></div>
                }
                maskClosable={false}
                centered
            >
                <>
                    <Scrollbars autoHide autoHeight autoHeightMax={600}>
                        {contentArr.map((item, index) => {
                            return (
                                <div key={index} style={{marginBottom: "10px"}}>
                                    <Row>
                                        <Col span={4}>
                                            <div className={"feedbackTitle"} style={{textAlign: "right"}}>{item.title}：
                                            </div>
                                        </Col>
                                        <Col span={20}>
                                            <div className={"feedbackContent"}>{item.content}</div>
                                        </Col>
                                    </Row>
                                </div>
                            )
                        })}
                    </Scrollbars>
                    {/*预览*/}
                    <Picture ref={ref => this.detailDialog = ref} path={this.previewPic}/>
                </>
            </Modal>
        )
    }
}